export default function Divider({ className = "" }: { className?: string }) {
  return <span className={`bg-white h-px block opacity-30 ${className}`} />;
}
